import { render, staticRenderFns } from "./WeeklyUserStatistics.vue?vue&type=template&id=8bdc3a48&"
import script from "./WeeklyUserStatistics.vue?vue&type=script&lang=js&"
export * from "./WeeklyUserStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports